import logo from "../../assets/logo/logo2.png";

const FooterIndex = () => {
  return (
    <div className="container-copy">
      <div className="all-container">
        <div className="container-flex-copy">
          <p className="copy" id="copy-first">
            © 2025. Todos los derechos reservados.
          </p>
          <img className="img-copy" src={logo} alt="Logo" />
        </div>
      </div>
    </div>
  );
};

export default FooterIndex;